import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Modal } from 'react-bootstrap';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class DesignationRequisitionGroupsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      modal: false,
      designation_requisition_id: this.props.designation_requisition_id,
      designation_requisition_groups: this.props.designation_requisition_groups,
      name: this.props.designation_requisition.name,
      aircraft_model: this.props.designation_requisition.aircraft_model,
      flight_time: this.props.designation_requisition.flight_time,
      commander_time: this.props.designation_requisition.commander_time,
      motor_time: this.props.designation_requisition.motor_time,
      similar_time: this.props.designation_requisition.similar_time,
      ifr_time: this.props.designation_requisition.ifr_time,
      model_time: this.props.designation_requisition.model_time,
      size_time: this.props.designation_requisition.size_time,
      commander_model_time: this.props.designation_requisition.commander_model_time,
      commander_motor_time: this.props.designation_requisition.commander_motor_time,
      exception: this.props.designation_requisition.exception,
      name_group: '',
      type: '',
    };
    //bind específico
    this.addRequisitionGroup = this.addRequisitionGroup.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.deleteGroup = this.deleteGroup.bind(this);
    this.editRequisition = this.editRequisition.bind(this);

    // Handlers
    this.locale = getLocale();

  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    this.setState({designation_requisition_id: newProps.designation_requisition_id});
    this.setState({designation_requisition_groups: newProps.designation_requisition_groups});
    this.setState({
      name: newProps.designation_requisition.name,
      aircraft_model: newProps.designation_requisition.aircraft_model,
      flight_time: newProps.designation_requisition.flight_time,
      commander_time: newProps.designation_requisition.commander_time,
      motor_time: newProps.designation_requisition.motor_time,
      similar_time: newProps.designation_requisition.similar_time,
      ifr_time: newProps.designation_requisition.ifr_time,
      model_time: newProps.designation_requisition.model_time,
      size_time: newProps.designation_requisition.size_time,
      commander_model_time: newProps.designation_requisition.commander_model_time,
      commander_motor_time: newProps.designation_requisition.commander_motor_time,
      exception: newProps.designation_requisition.exception,
    });
    if (newProps.modal_props === true) {
      this.setState({ modal: true});
    }
  }

  addRequisitionGroup(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      name: this.state.name_group,
      designation_requisition_id: this.state.designation_requisition_id,
      type: this.state.type,
    };
    var self = this;
    var header = this.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/designacao/requisicao/grupo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.loadData(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  closeModal() {
    this.setState({
      modal: false,
      designation_requisition_id: undefined,
      designation_requisition_groups: undefined,
      name_group: '',
      type: '',
    }, this.props.closeModalParent());
  }

  deleteGroup (event) {
    var designation_requisition_group_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.deletarGrupo);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.props.RequestApi.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/designacao/requisicao/grupo/' + designation_requisition_group_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.loadData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  editRequisition(event) {
    event.preventDefault();
    var datasave = {
      designation_requisition_id: this.state.designation_requisition_id,
      name: this.state.name,
      flight_time: this.state.flight_time,
      commander_time: this.state.commander_time,
      motor_time: this.state.motor_time,
      similar_time: this.state.similar_time,
      ifr_time: this.state.ifr_time,
      model_time: this.state.model_time,
      size_time: this.state.size_time,
      commander_model_time: this.state.commander_model_time,
      commander_motor_time: this.state.commander_motor_time,
      exception: this.state.exception,
    };
    var self = this;
    self.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/designacao/requisicao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.loadData(responseJson);
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
    <RequestApi ref={'request_api'} />
    <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
      <Modal.Header>
        <h4 className="pull-left">{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.tituloEditarRequisitos} - {self.state.aircraft_model}</h4>
        <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
        <i className="fa fa-fw fa-close"></i></button>
        <div className="clearfix"></div>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={this.editRequisition}> 
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.TotalDeHorasDeVooEmModelosDeComplexidadeSimilar}:</label>
                <input value={this.state.similar_time} name="similar_time" className="form-control" onChange={this.handleChange.bind(this, 'similar_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.placeholder.TotalDeHorasDeVooEmModelosDeComplexidadeSimilar} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.TotalGeralDeHorasDeVoo}:</label>
                <input value={this.state.flight_time} name="flight_time" className="form-control" onChange={this.handleChange.bind(this, 'flight_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.placeholder.TotalGeralDeHorasDeVoo} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.TotalDeHorasDeVooNoModeloExato}:</label>
                <input value={this.state.model_time} name="model_time" className="form-control" onChange={this.handleChange.bind(this, 'model_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.placeholder.TotalDeHorasDeVooNoModeloExato} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.TotalDeHorasEmComando}:</label>
                <input value={this.state.commander_time} name="commander_time" className="form-control" onChange={this.handleChange.bind(this, 'commander_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.placeholder.TotalDeHorasEmComando} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.TotalDeHorasEmComandoNoModeloExato}:</label>
                <input value={this.state.commander_model_time} name="commander_model_time" className="form-control" onChange={this.handleChange.bind(this, 'commander_model_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.placeholder.TotalDeHorasEmComandoNoModeloExato} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.TotalDeHorasDeVooComOTipoDeMotor}:</label>
                <input value={this.state.motor_time} name="motor_time" className="form-control" onChange={this.handleChange.bind(this, 'motor_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.placeholder.TotalDeHorasDeVooComOTipoDeMotor} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.TotalDeHorasDeVooEmComandoNoTipoDeMotor}:</label>
                <input value={this.state.commander_motor_time} name="commander_motor_time" className="form-control" onChange={this.handleChange.bind(this, 'commander_motor_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.placeholder.TotalDeHorasDeVooEmComandoNoTipoDeMotor} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.TotalDeHorasDeVooEmIFR}:</label>
                <input value={this.state.ifr_time} name="ifr_time" className="form-control" onChange={this.handleChange.bind(this, 'ifr_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.placeholder.TotalDeHorasDeVooEmIFR} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.TotalDeHorasDeVooEmModeloDeMesmoPorte}:</label>
                <input value={this.state.size_time} name="size_time" className="form-control" onChange={this.handleChange.bind(this, 'size_time')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.placeholder.TotalDeHorasDeVooEmModeloDeMesmoPorte} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.Nome}:</label>
                <input value={this.state.name} name="name" className="form-control" onChange={this.handleChange.bind(this, 'name')} placeholder={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.placeholder.NomeDoRegistro} required />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.Excecao}:</label>
                <br/>
                <Toggle
                  checked={this.state.exception}
                  aria-label='No label tag'
                  name="exception"
                  onChange={this.handleToggleChange.bind(this, 'exception')} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.formularioEditarRequisito.botaoEditarRequisito}</button>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
        <i className="fa fa-fw fa-close"></i></button>
      </Modal.Footer>
    </Modal>
</div>
    );
  }
}

export default DesignationRequisitionGroupsModal;



// WEBPACK FOOTER //
// ./src/Components/Designations/Elements/DesignationRequisitionGroupsModal.js